export default {
  login: {
    logIn: 'Log in',
    username: 'Username',
    password: 'Password',
    verifycode: 'Verify Code'
  },
  mobile: {
    PwCYouPlusProgramme: 'PwC You Plus Programme',
    PwCYouPlusAnchorPro: 'PwC You Plus Anchor Pro',
    more: 'More',
    home: 'Home',
    careerDevelopment: 'Career Development',
    careerInsights: 'Career Insights',
    latestEvents: 'Latest Events',
    careerOpportunities: 'Career Opportunities',
    careerProgrammes: 'Career Programmes',
    capabilityDiagnosis: 'Capability Diagnosis',
    peerSharing: 'Peer Sharing',
    peerStories: 'Peer Stories',
    highlightMoments: 'Highlight Moments',
    campusAmbassador: 'Campus Ambassador',
    callForLetters: 'Call for Letters',
    internshipChallenge: 'internship Challenge',
    careerCapabilitySelfDiagnosis: 'Career Capability Self-Diagnosis',
    on1CustomisedCounselling: '1 on 1 Customised Counselling',
    diagnose: 'Diagnose Now',
    goApply: 'Go Apply',
    apply: 'Apply',
    applied: 'Applied',
    completed: 'Completed',
    reject: 'Reject',
    accept: 'Accept',
    consulted: 'Submitted',
    consult: 'Book a Consultation '
  }
}
